import {Sport} from '@/types/common';
import {Avatar, Box, Tooltip} from '@mui/material';
import {styled} from '@mui/system';
import React from 'react';

export interface Participant {
  name: string | undefined;
  color: string | undefined;
  picture: string | undefined;
  _id: string;
  updatedAt: string | undefined;
  birthday?: string | undefined;
  gender?: string | undefined;
  description?: string | undefined;
  hometown?: string | undefined;
  sports?: Array<{level: number; sport: Sport}> | null;
}

interface ParticipantAvatarBigProps {
  participant: Participant;
  index: number;
  onClick?: () => void;
  tooltipAndClickable?: boolean;
}

const StyledAvatar = styled(Avatar)<{
  clickable?: boolean;
}>(({color, clickable}) => ({
  backgroundColor: color,
  cursor: clickable ? 'pointer' : 'default',
  objectFit: 'cover'
}));

const getImageSource = (participant: Participant): string => {
  if (participant.picture) {
    return `${participant.picture}?timestamp=${participant.updatedAt}`;
  }
  return '';
};

const ParticipantAvatarBig: React.FC<ParticipantAvatarBigProps> = ({
  participant,
  onClick,
  tooltipAndClickable
}) => {
  let initials = '';

  if (participant.name) {
    const nameParts = participant.name.split(' ');

    if (nameParts.length === 1) {
      initials = nameParts[0].charAt(0).toUpperCase();
    } else {
      initials = nameParts
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
    }
  }

  const avatar = (
    <StyledAvatar
      sx={{
        height: {xs: '60px', sm: '80px', md: '120px', lg: '150px'},
        width: {xs: '60px', sm: '80px', md: '120px', lg: '150px'},
        fontSize: {sm: '18px', md: '28px', lg: '32px'}
      }}
      alt={participant.name}
      color={participant.color}
      src={getImageSource(participant)}
      onClick={tooltipAndClickable ? onClick : undefined}
      clickable={tooltipAndClickable}
    >
      {!participant.picture && initials}
    </StyledAvatar>
  );

  return (
    <Box m={1} ml={1}>
      {tooltipAndClickable ? (
        <Tooltip title={participant.name ? participant.name : ''}>
          {avatar}
        </Tooltip>
      ) : (
        avatar
      )}
    </Box>
  );
};

export default ParticipantAvatarBig;
